module.exports = __webpack_public_path__ + "img/28.1ede42d3.jpg";